/**
 * 
 * @param {number} value 
 * @param {number} dp 
 * @returns 
 */
export const toFixedIfNecessary = (value, dp) => {
    return +parseFloat(String(value)).toFixed(dp);
}